import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Container,
  Heading,
  VStack,
  HStack,
  Image,
  Text,
  IconButton,
  useColorMode,
  Divider,
  Button,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import { FiPlay, FiHeart, FiMoreVertical, FiShuffle } from "react-icons/fi";
import { PiHeartStraightFill } from "react-icons/pi";
import axios from "axios";
import { useMusic } from "../context/MusicContext";
import AudioVisualizer from "../components/AudioVisualizer";
import Cookies from "js-cookie";
const MotionBox = motion(Box);

const Favorites = () => {
  const { colorMode } = useColorMode();
  const [isloading, setIsloading] = useState(false);
  // Mock data for favorite songs
  const [favoriteSongs, setfavoriteSongs] = useState([]);
  const [isFAV, setIsFAV] = useState(false);
  const {setCurrentList,audioRef, currentTime, currentTrack, setCurrentTrack, setIsPlaying ,IsPlaying } =
    useMusic();
  const User = useRef(JSON.parse(Cookies.get("User")));

  useEffect(() => {
    setIsloading(true);
    axios
      .get(`https://apiArmanify.zx-tm.ir/api/FevSongs/user/${User.current.userId}`)
      .then((res) => {
        let FAV_Link = res.data;
        let data = [];
        
        FAV_Link.forEach((link) => {
          console.warn(link);
          data.push({
            page_url: link.pageUrl,
            title: link.title,
            artist: link.title,
            songUrl: link.mp3Url,
            cover: link.coverUrl,
            isPlaying: link.mp3Url == currentTrack.url
          });
        });
        setfavoriteSongs(data);
        setCurrentList(data);
        setIsloading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function play(url, data) {
    favoriteSongs.forEach((item) => {
      item.isPlay = false;
    });
    
    axios
      .get(`https://apiArmanify.zx-tm.ir/api/songs/music?url=${url}`)
      .then((response) => {
        setCurrentTrack({
          page_url: url,
          title: response.data.title,
          artist: response.data.title,
          cover: response.data.coverUrl,
          url: response.data.mp3Url,
          duration: 0,
        });
        data.isPlay = true;
        setIsPlaying(true);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  function Add_FAV(url) {
    axios.post(`https://apiArmanify.zx-tm.ir/api/FevSongs/delete/${User.current.userId}?url=${url}`)
    .then(res => {
      const updatedSongs = favoriteSongs.filter(
        (item) => item.songUrl !== url
      );
      setfavoriteSongs(updatedSongs);
    })
    .catch(err => {
      alert("خطا در حذف از علاقه مندی");
     
    });

  }

  return (
    <Container maxW="container.xl" py={8}>
      <VStack spacing={8} align="stretch">
        <HStack justify="space-between">
          <Heading size="xl">مورد علاقه‌ها</Heading>
          <Button
            leftIcon={<FiShuffle />}
            colorScheme="brand"
            variant="outline"
          >
            پخش تصادفی
          </Button>
        </HStack>
        <span
          className="loader"
          style={{ display: isloading ? "block" : "none" }}
        ></span>
        <Box
          bg={colorMode === "dark" ? "gray.700" : "white"}
          borderRadius="xl"
          overflow="hidden"
          boxShadow="lg"
        >
          {favoriteSongs.map((data, index) => (
            <MotionBox
              key={index}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
            >
              <HStack
                p={4}
                spacing={4}
                _hover={{
                  bg: colorMode === "dark" ? "gray.600" : "gray.50",
                }}
                cursor="pointer"
              >
                <Image
                  src={data.cover}
                  alt={data.title}
                  boxSize="50px"
                  borderRadius="md"
                />
                <Box flex="1">
                  <Text fontWeight="bold">{data.title}</Text>
                  {/* <Text fontSize="sm" color="gray.500">
                    {data.title}
                  </Text> */}
                </Box>
                <HStack spacing={2}>
                  <IconButton
                    icon={<PiHeartStraightFill />}
                    variant="ghost"
                    colorScheme="red"
                    aria-label="Remove from favorites"
                    onClick={() => Add_FAV(data.songUrl)}
                  />
                  <IconButton
                    onClick={() => play(data.page_url, data)}
                    icon={data.isPlay ? <AudioVisualizer /> : <FiPlay />}
                    variant="ghost"
                    colorScheme="brand"
                    aria-label="Play"
                  />
                </HStack>
              </HStack>
              {/* {index < favoriteSongs.length - 1 && <Divider />} */}
            </MotionBox>
          ))}
        </Box>
      </VStack>
    </Container>
  );
};

export default Favorites;
